function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3745 15.2456C20.3745 11.4367 17.0204 8.30034 12.6903 7.84255C13.0044 7.54258 13.2036 7.11814 13.2036 6.64325C13.2036 5.73582 12.4858 5.00013 11.6 5.00013C10.7142 5.00013 9.9963 5.73582 9.9963 6.64325C9.9963 7.11814 10.1956 7.54258 10.5097 7.84255C6.17957 8.30034 2.82554 11.4367 2.82554 15.2456H20.3745ZM9.04057 10.1334C7.80736 10.5381 6.76263 11.2928 6.0984 12.2588C6.00243 12.399 5.8496 12.4733 5.69483 12.4733C5.59656 12.4733 5.49736 12.4437 5.41103 12.3812C5.18852 12.2206 5.13529 11.9048 5.29191 11.6771C6.07917 10.5322 7.30366 9.64184 8.74011 9.17136C9.00048 9.08578 9.27691 9.23322 9.36002 9.4984C9.4428 9.76424 9.29993 10.0485 9.04057 10.1334Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6138 15.9787H2.58633C2.0415 15.9787 1.60003 16.4314 1.60003 16.9894C1.60003 17.5474 2.0415 18.0001 2.58633 18.0001H20.6138C21.1586 18.0001 21.6 17.5474 21.6 16.9894C21.6 16.4315 21.1586 15.9787 20.6138 15.9787Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.20003 8.30013C2.97912 8.46582 2.66571 8.42105 2.50003 8.20013L0.100029 5.00013C-0.0656561 4.77922 -0.0208844 4.46582 0.200029 4.30013C0.420943 4.13445 0.734344 4.17922 0.900029 4.40013L3.30003 7.60013C3.46571 7.82104 3.42094 8.13445 3.20003 8.30013Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.61228 5.02571C8.33757 5.05385 8.09206 4.85398 8.06392 4.57928L7.65619 0.60011C7.62804 0.325406 7.82791 0.0798964 8.10262 0.0517486C8.37732 0.0236009 8.62283 0.223474 8.65098 0.498178L9.05871 4.47734C9.08685 4.75205 8.88698 4.99756 8.61228 5.02571Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.29234 6.96167C6.03744 7.06788 5.7447 6.94734 5.63849 6.69244L3.13849 0.692438C3.03228 0.437537 3.15282 0.144801 3.40772 0.038592C3.66262 -0.0676166 3.95536 0.0529219 4.06157 0.307823L6.56157 6.30782C6.66778 6.56272 6.54724 6.85546 6.29234 6.96167Z",
  fill: "black"
});

var SvgCallServer = function SvgCallServer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCallServer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/callServer.d4544c56.svg";
export { ForwardRef as ReactComponent };